// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__jPf2q","footerContainer":"Footer_footerContainer__1QbG_","phoneIcon":"Footer_phoneIcon__ZlGSM"};